import { ConfigAI } from '@gimlite/common/stores/ai.store';
import { ConfigDialog } from '@gimlite/common/stores/dialog.store';
import { ConfigGQL } from '@gimlite/common/stores/gql.store';
import { ConfigI18N } from '@gimlite/common/stores/i18n.store';
import { ConfigMaps as ConfigMapsCommon } from '@gimlite/common/stores/maps.store';
import { ConfigNotification as ConfigNotificationCommon } from '@gimlite/common/stores/notification.store';
import { ConfigSocket } from '@gimlite/common/stores/socket.store';
import { ConfigSSO } from '@gimlite/common/stores/sso.store';
import { ConfigWizard } from '../stores/wizard.store';
import { observer } from 'mobx-react-lite';
import { MapsProvider } from '../components/maps/maps.provider';
import { ConfigApp } from '../stores/app.store';
import { ConfigMenu } from '../stores/menu.store';
import { ConfigRoot } from '../stores/root.store';
import { ConfigTheme } from '../stores/theme.store';
import { useStoreUIV2 } from './useStore.hook';

const ConfigNotificationUIV2 = observer(
  ({ children }: { children: React.ReactNode }) => (
    <ConfigNotificationCommon ui="v2">{children}</ConfigNotificationCommon>
  ),
);

const ConfigMaps = observer(
  ({
    children,
    token,
    mapId,
  }: {
    children: React.ReactNode;
    token: string;
    mapId?: string;
  }) => {
    const { MapsStore } = useStoreUIV2();

    return (
      <ConfigMapsCommon token={token} mapId={mapId}>
        {MapsStore.load && MapsStore.token ? (
          <MapsProvider token={MapsStore.token} mapId={MapsStore.mapId}>
            {children}
          </MapsProvider>
        ) : null}
      </ConfigMapsCommon>
    );
  },
);

export const useConfigUIV2 = () => ({
  ConfigAI,
  ConfigDialog,
  ConfigGQL,
  ConfigI18N,
  ConfigMaps,
  ConfigNotification: ConfigNotificationUIV2,
  ConfigSSO,
  ConfigApp,
  ConfigMenu,
  ConfigTheme,
  ConfigSocket,
  ConfigRoot,
  ConfigWizard,
});
